import { Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";
import PlanesPage from "./components/pages/PlanesPage";
import ContactoPage from "./components/pages/ContactoPage";
import NosotrosPage from "./components/pages/NosotrosPage";
import ComoFuncionaPage from "./components/pages/ComoFuncionaPage";
import ComoFuncionaInmobiliariasPage from "./components/pages/ComoFuncionaInmobiliariasPage";
import ComoFuncionaClientesPage from "./components/pages/ComoFuncionaClientesPage";
import DocumentacionPage from "./components/pages/DocumentacionPage";
import DocumentacionGeoJSONPage from "./components/pages/DocumentacionGeoJSONPage";
import ConvertirGeoJSONPage from "./components/pages/ConvertirGeoJSONPage";
import ServiciosConversionPage from "./components/pages/ServiciosConversionPage";
import MobileAppPage from "./components/pages/MobileAppPage";
import IntegracionCRMPage from "./components/pages/IntegracionCRMPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/planes" element={<PlanesPage />} />
      <Route path="/contacto" element={<ContactoPage />} />
      <Route path="/nosotros" element={<NosotrosPage />} />
      <Route path="/como-funciona" element={<ComoFuncionaPage />} />
      <Route path="/como-funciona/inmobiliarias" element={<ComoFuncionaInmobiliariasPage />} />
      <Route path="/como-funciona/clientes" element={<ComoFuncionaClientesPage />} />
      <Route path="/documentacion" element={<DocumentacionPage />} />
      <Route path="/documentacion-geojson" element={<DocumentacionGeoJSONPage />} />
      <Route path="/convertir-geojson" element={<ConvertirGeoJSONPage />} />
      <Route path="/servicios-conversion" element={<ServiciosConversionPage />} />
      <Route path="/app-movil" element={<MobileAppPage />} />
      <Route path="/integracion-crm" element={<IntegracionCRMPage />} />
    </Routes>
  );
}

export default App;
